/* @ngInject */
function FloatingBarUserController ($scope, $rootScope, $q, $translate, $state, AssetPreviewService, UdsModalService, MessageService, ArtsService, ToastService, ConfirmationModalService, ModalService, SocialMediaService) {
  const getShareArtDialogController = () => $q.when(import('../../dialogs/share-art/share-art-dialog.controller'))
  const getMoveArtToFolderController = () => $q.when(import('../../dialogs/move-art-to-folder/move-art-to-folder-dialog.controller'))

  $scope.loading = false

  const api = {
    getShareArtDialogController,
    getMoveArtToFolderController,
    _defineActionButtons,
    _resetActionButtons,
    _getCollectionActions,
    _getSingleCustomizableTemplateActions,
    _getSingleDownloadableTemplateActions,
    _getMultipleDownloadableTemplatesActions,
    _showMobileDialog,
    _defineArtListActionButtons,
    _defineOtherActionButtons,
    _getDefaultActions,
    _convertActionsToObject,
    _removeActionForMultipleSelection,
    _onDuplicateClick,
    _onOrganizeClick,
    _onArchiveClick,
    _emitReloadPage,
    _archiveArts,
    _verifyInstagramAction
  }

  this.getApi = () => api

  activate()

  function activate () {
    api._resetActionButtons()
  }

  $scope.$watchCollection('selectedTemplates', () => {
    api._defineActionButtons()
  })
  $scope.$watchCollection('selectedCollections', () => {
    api._defineActionButtons()
  })

  $scope.unselectAllAssets = () => {
    $scope.onUnselectAllAssets()
  }

  $scope.getFloatingBarTitle = () => {
    const templatesCount = $scope.selectedTemplates?.length || 0
    const collectionsCount = $scope.selectedCollections?.length || 0
    const textNeedsPlural = (templatesCount + collectionsCount) > 1

    if (textNeedsPlural) {
      return $translate.instant('selectedsLowerCase')
    }

    return $translate.instant('selectedLowerCase')
  }

  $scope.getFloatingBarCounter = () => {
    const templatesCount = $scope.selectedTemplates?.length || 0
    const collectionsCount = $scope.selectedCollections?.length || 0

    return templatesCount + collectionsCount
  }

  $scope.onPreviewClick = () => {
    AssetPreviewService.openAssetPreview({
      asset: $scope.selectedTemplates[0],
      location: $scope.floatingBarLocation,
      fromCampaignAction: false,
      getPreviewAssets: () => {
        return Promise.resolve({
          count: 0,
          rows: []
        })
      }
    })
  }

  $scope.onInstagramClick = () => {
    const ids = $scope.selectedTemplates.map(template => template.id)
    return $state.go('arts.socialMedia', {
      templateIds: ids
    })
  }

  $scope.onShareClick = () => {
    api.getShareArtDialogController().then(({ ShareArtDialogController }) => {
      const shareArtDialog = UdsModalService.createModal({
        controller: ShareArtDialogController,
        modalName: 'shareArtDialog',
        data: {
          art: $scope.selectedTemplates[0]
        }
      })

      shareArtDialog.open()
    })
  }

  $scope.onDownloadClick = () => {
    const render = $scope.location === 'artList'
    $scope.$emit('downloadMaterialsTab.start-download', render, $scope.selectedTemplates, $scope.selectedCollections)
  }

  $scope.onEditClick = () => {
    const template = $scope.selectedTemplates[0]

    if (!$rootScope.isDesktop && template.customizationLevel !== 'ONLY_DOWNLOAD') {
      api._showMobileDialog()
      return
    }

    if (template.isTemplate) {
      $state.go('customizeTemplate', {
        from: $state.current.name,
        fromParams: $state.params,
        templateId: template.id
      })
    } else {
      $state.go('customizeArt', {
        idArt: template.id,
        from: $state.current.name,
        fromParams: $state.params
      })
    }
  }

  function _showMobileDialog () {
    MessageService.error({
      title: $translate.instant('oopsTitle'),
      text: $translate.instant('mobileCustomizeNotAllowed') + '\n\n' + $translate.instant('continueWorkOnPC'),
      confirmButtonText: $translate.instant('ok')
    })
  }

  function _defineActionButtons () {
    api._resetActionButtons()

    if ($scope.location === 'artList') {
      api._defineArtListActionButtons()
    } else {
      api._defineOtherActionButtons()
    }
  }

  function _defineArtListActionButtons () {
    const { APPROVED_OR_NOT_NEED_APPROVAL, NEED_APPROVAL, REPROVED_OR_UNAVAILABLE } = api._getDefaultActions()

    const hasApprovedOrNotNeedApproval = $scope.selectedTemplates.some(template => template.approvalStatus === 'APPROVED' || !template.needApproval)
    const hasNeedApproval = $scope.selectedTemplates.some(template => template.needApproval && (template.approvalStatus === 'DESIGNING' || template.approvalStatus === 'PENDING_APPROVAL' || template.approvalStatus === 'PENDING_REWORK'))
    const hasReprovedOrUnavailable = $scope.selectedTemplates.some(template => template.approvalStatus === 'REJECTED' || template.unavailable)

    let actions = []

    if (hasApprovedOrNotNeedApproval) {
      actions = [...APPROVED_OR_NOT_NEED_APPROVAL]
    }

    if (hasNeedApproval) {
      if (actions.length) {
        actions = actions.filter(value => NEED_APPROVAL.includes(value))
      } else {
        actions = [...NEED_APPROVAL]
      }
    }

    if (hasReprovedOrUnavailable) {
      if (actions.length) {
        actions = actions.filter(value => REPROVED_OR_UNAVAILABLE.includes(value))
      } else {
        actions = [...REPROVED_OR_UNAVAILABLE]
      }
    }

    actions = api._removeActionForMultipleSelection(actions)

    $scope.actionButtons = api._convertActionsToObject(actions)

    api._verifyInstagramAction()
  }

  function _defineOtherActionButtons () {
    const singleTemplate = $scope.selectedTemplates?.length === 1
    const hasSelectedCollections = $scope.selectedCollections?.length > 0
    const onlyDownloadableTemplates = $scope.selectedTemplates.every(template => !template.isCustomizable || template.customizationLevel === 'ONLY_DOWNLOAD')
    const customizableTemplates = $scope.selectedTemplates.every(template => template.isCustomizable && template.customizationLevel !== 'ONLY_DOWNLOAD')

    if (hasSelectedCollections) {
      $scope.actionButtons = _getCollectionActions()
    } else if (singleTemplate && customizableTemplates) {
      $scope.actionButtons = _getSingleCustomizableTemplateActions()
    } else if (singleTemplate && onlyDownloadableTemplates) {
      $scope.actionButtons = _getSingleDownloadableTemplateActions()
    } else if (onlyDownloadableTemplates) {
      $scope.actionButtons = _getMultipleDownloadableTemplatesActions()
    }

    api._verifyInstagramAction()
  }

  function _resetActionButtons () {
    $scope.actionButtons = {
      preview: false,
      instagram: false,
      share: false,
      download: false,
      edit: false,
      more: false
    }
  }

  function _getCollectionActions () {
    return {
      preview: false,
      instagram: false,
      share: false,
      download: true,
      edit: false
    }
  }

  function _getSingleCustomizableTemplateActions () {
    return {
      preview: true,
      instagram: false,
      share: false,
      download: false,
      edit: true
    }
  }

  function _getSingleDownloadableTemplateActions () {
    const showSocialButton = SocialMediaService.showSocialButton($scope.selectedTemplates[0], $rootScope.isUser(), $rootScope.isEnableSocialMedia)

    return {
      preview: true,
      instagram: showSocialButton,
      share: true,
      download: true,
      edit: false
    }
  }

  function _getMultipleDownloadableTemplatesActions () {
    const showSocialButton = $scope.selectedTemplates.every(template => SocialMediaService.showSocialButton(template, $rootScope.isUser(), $rootScope.isEnableSocialMedia))

    return {
      preview: false,
      instagram: showSocialButton,
      share: false,
      download: true,
      edit: false
    }
  }

  function _getDefaultActions () {
    return {
      APPROVED_OR_NOT_NEED_APPROVAL: ['preview', 'instagram', 'share', 'download', 'duplicate', 'organize', 'archive'],
      NEED_APPROVAL: ['preview', 'edit', 'duplicate', 'organize', 'archive'],
      REPROVED_OR_UNAVAILABLE: ['preview', 'organize', 'archive']
    }
  }

  function _removeActionForMultipleSelection (actions) {
    const excludeActions = ['preview', 'edit', 'share', 'duplicate']

    if ($scope.selectedTemplates.length > 1) {
      actions = actions.filter(action => !excludeActions.includes(action))
    }

    return actions
  }

  function _convertActionsToObject (actions) {
    const moreOptions = ['duplicate', 'organize', 'archive']
    const icons = {
      duplicate: 'copy',
      organize: 'dam',
      archive: 'archive'
    }

    const object = {}
    const more = {
      options: []
    }

    actions.forEach(action => {
      if (moreOptions.includes(action)) {
        more.options.push({
          text: $translate.instant(action),
          icon: icons[action],
          click: () => {
            if (action === 'duplicate') {
              api._onDuplicateClick()
            } else if (action === 'organize') {
              api._onOrganizeClick()
            } else if (action === 'archive') {
              api._onArchiveClick()
            }
          }
        })
      } else {
        object[action] = true
      }
    })

    if (more.options.length) {
      object.more = more
    }

    return object
  }

  function _onDuplicateClick () {
    $scope.loading = true
    ArtsService.cloneArt($scope.selectedTemplates[0].id)
      .then((response) => {
        $state.go('customizeArt', {
          idArt: response.id,
          from: $state.current.name,
          fromParams: $state.params
        })
      })
      .catch(ToastService.defaultErrorToast)
      .finally(() => {
        $scope.loading = false
      })
  }

  function _onOrganizeClick () {
    api.getMoveArtToFolderController().then(({ MoveArtToFolderController }) => {
      return ModalService.showModal({
        templateId: 'moveArtToFolderController.html',
        templateUrl: '/arts/dialogs/move-art-to-folder/move-art-to-folder-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: MoveArtToFolderController,
        data: {
          templates: $scope.selectedTemplates
        }
      }).then(info => {
        if (info && info.changed) {
          api._emitReloadPage()
        }
      })
    })
  }

  function _emitReloadPage () {
    $scope.onUnselectAllAssets()
    $scope.$emit('reload-arts-page')
  }

  function _onArchiveClick () {
    ConfirmationModalService.createModal({
      title: $translate.instant('archive'),
      description: $translate.instant('areYouSureArchiveArts'),
      buttonCancelText: $translate.instant('cancel'),
      buttonConfirmText: $translate.instant('campaignEdit.archiveConfirm.confirm'),
      onConfirm: () => {
        api._archiveArts($scope.selectedTemplates)
      }
    })
  }

  function _archiveArts (templates) {
    $scope.loading = true
    const ids = templates.map(template => template.id)

    ArtsService.bulkArchiveTemplates(ids).then(() => {
      ToastService.defaultSuccessToast()
      api._emitReloadPage()
    }).catch(() => {
      ToastService.defaultErrorToast()
    }).finally(() => {
      $scope.loading = false
    })
  }

  function _verifyInstagramAction () {
    if (!$scope.actionButtons.instagram) return

    const showSocialButton = $scope.selectedTemplates.every(template => SocialMediaService.showSocialButton(template, $rootScope.isUser(), $rootScope.isEnableSocialMedia))

    if (!showSocialButton) {
      $scope.actionButtons.instagram = false
      return
    }

    let layerCount = 0
    $scope.selectedTemplates.forEach(template => {
      if (template.layers?.length) {
        layerCount += template.layers.length
      }
    })

    if (layerCount > 10) {
      $scope.actionButtons.instagram = false
    }
  }
}

export { FloatingBarUserController }
